<template>
  <span class="right">
    <span @click="$emit('title-click')">
      当前位置：{{ $store.state.game.info.title }} &gt;
    </span>
    <span
      v-for="(txt, i) in list"
      :key="i"
      :class="{ cur: i === list.length - 1 }"
      @click="$emit('title-click')"
    >
      {{ txt + (i === list.length - 1 ? '' : '&gt;') }}
    </span>
  </span>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    }
  }
}
</script>
